/* __next_internal_client_entry_do_not_use__ AppProviders auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Sentry from "@sentry/nextjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SessionProvider, useSession } from "next-auth/react";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { identifyAmplitudeUser, initAmplitude, resetAmplitudeUser, trackPageView } from "../../lib/amplitude";
const reactQueryConfig = {
    defaultOptions: {
        queries: {
            staleTime: 60 * 1000 * 5,
            refetchOnWindowFocus: false,
            retry: false
        }
    }
};
const SentryUserSync = ()=>{
    var _session_user;
    const { data: session, status } = useSession();
    const email = session === null || session === void 0 ? void 0 : (_session_user = session.user) === null || _session_user === void 0 ? void 0 : _session_user.email;
    useEffect(()=>{
        if (status === "loading") return;
        Sentry.setUser(email ? {
            email
        } : null);
    }, [
        email,
        status
    ]);
    return null;
};
const AmplitudeProvider = ()=>{
    var _session_user, _session_user1;
    const { data: session, status } = useSession();
    const pathname = usePathname();
    const lastTrackedPath = useRef(null);
    useEffect(()=>{
        initAmplitude();
    }, []);
    useEffect(()=>{
        var _session_user;
        if (status === "loading") return;
        const userId = session === null || session === void 0 ? void 0 : (_session_user = session.user) === null || _session_user === void 0 ? void 0 : _session_user.userId;
        if (userId) {
            var _session_user1;
            var _session_user_email;
            identifyAmplitudeUser(String(userId), {
                email: (_session_user_email = session === null || session === void 0 ? void 0 : (_session_user1 = session.user) === null || _session_user1 === void 0 ? void 0 : _session_user1.email) !== null && _session_user_email !== void 0 ? _session_user_email : ""
            });
            return;
        }
        resetAmplitudeUser();
    }, [
        session === null || session === void 0 ? void 0 : (_session_user = session.user) === null || _session_user === void 0 ? void 0 : _session_user.email,
        session === null || session === void 0 ? void 0 : (_session_user1 = session.user) === null || _session_user1 === void 0 ? void 0 : _session_user1.userId,
        status
    ]);
    useEffect(()=>{
        if (!pathname || pathname === lastTrackedPath.current) return;
        lastTrackedPath.current = pathname;
        trackPageView(pathname);
    }, [
        pathname
    ]);
    return null;
};
export const AppProviders = (param)=>{
    let { children } = param;
    const [queryClient] = useState(()=>new QueryClient(reactQueryConfig));
    return /*#__PURE__*/ _jsxs(SessionProvider, {
        children: [
            /*#__PURE__*/ _jsx(SentryUserSync, {}),
            /*#__PURE__*/ _jsx(AmplitudeProvider, {}),
            /*#__PURE__*/ _jsx(QueryClientProvider, {
                client: queryClient,
                children: children
            })
        ]
    });
};
